<template>
    <div class="modal-wrapper" :class="{ hide: !modals.register }">
        <BaseLogo class="theme_3-logo" :src="logoComputed" :height="logo.height">
            <template v-if="!logoComputed" #logo-placeholder>
                <span class="brand">{{ tokens.header.cfd }}</span>
                {{ tokens.header.platform }}
            </template>
        </BaseLogo>
        <div class="modal">
            <div class="title-wrapper">
                <BaseModalTitle>
                    <template #left>
                        <div class="modal-title-left">
                            <i class="material-icons">app_registration</i>
                            <span class="title__medium">{{ tokens.newDesign.registration }}</span>
                        </div>
                    </template>
                    <template #right>
                        <div class="modal-title-right">
                            <span class="label__medium">{{ tokens.loginModal.haveAccount }}</span>
                            <BaseButtonSmall
                                :buttonText="tokens.newDesign.signIn"
                                :buttonStyle="'tonal-secondary'"
                                @click.native="goToLoginPage" />
                        </div>
                    </template>
                </BaseModalTitle>
            </div>
            <div class="modal-box">
                <BaseInput
                    v-model="email"
                    name="email"
                    :title="tokens.registerModal.email"
                    :placeholder="tokens.registerModal.email" @keyup.native.enter="register" />
                <div class="name-inputs">
                    <BaseInput
                        v-model="firstname"
                        :title="tokens.registerModal.firstName"
                        :placeholder="tokens.newDesign.firstname"
                        @keyup.native.enter="register" />
                    <BaseInput
                        v-model="lastname"
                        :title="tokens.registerModal.lastName"
                        :placeholder="tokens.registerModal.lastname"
                        @keyup.native.enter="register" />
                </div>
                <SearchCountrySelect
                    :title="tokens.registerModal.country"
                    :value="country"
                    @update="chooseCountry" />
                <BaseInput
                    v-model="phone"
                    name="phone"
                    autocomplete="off"
                    :title="tokens.registerModal.phone"
                    :type="'text'"
                    :placeholder="tokens.registerModal.phone"
                    @keyup.native="filPhoneNumber" @keyup.native.enter="register" />
                <BaseInput
                    v-model="password"
                    name="password"
                    autocomplete="off"
                    :title="tokens.registerModal.password"
                    :type="'password'"
                    :placeholder="tokens.loginModal.yourPassword"
                    @keyup.native.enter="register" />
                <BaseInput
                    v-model="password2"
                    name="password"
                    autocomplete="off"
                    :title="tokens.registerModal.repeatPassword"
                    :type="'password'"
                    :placeholder="tokens.loginModal.yourPassword"
                    @keyup.native.enter="register" />
                <SearchCurrencySelect
                    :maxShowed="4"
                    :value="currencyChosen"
                    @update="currencyChosen = $event" 
                    :title="tokens.orderMenu.currency"/>
                <BaseInput
                    v-if="existPromo"
                    v-model="manager_id"
                    :title="tokens.loginModal.promo" />
            </div>
            <div class="modal-footer">
                <BaseButton
                    :buttonStyle="'filled-primary'"
                    :buttonText="tokens.registerModal.createAccount"
                    @click.native="register"
                    @keydown.native.enter="register" />
            </div>
            <div class="modal-footer-additional">
                <label
                    class="promo label__medium"
                    @click="existPromo = !existPromo"
                    >{{ tokens.loginModal.havePromo }}
                </label>
                <div v-if="privacyAndPolicyLink" class="privacy-policy">
                    <a :href="privacyAndPolicyLink"
                        class="label__medium">{{ tokens.registerModal.privacyAndPolicy }}</a>
                </div>
                <div v-if="customerAgreementLink.link" class="customer-agreement">
                    <template v-if="customerAgreementLink.type === 'termsAndConditions'">

                        <BaseCheckbox
                            @click.native="customerAgreementLinkCheckbox = !customerAgreementLinkCheckbox" 
                        />
                        <span class="label__medium">{{ tokens.registerModal.iConfirm }}</span>
                        <a  :href="customerAgreementLink.link" 
                            class="label__medium" 
                            @click="openAgreement"
                        >
                            {{ tokens.registerModal.termsAndConditions }}
                        </a>
                    </template>
                    <template v-else>

                        <BaseCheckbox
                            @click.native="customerAgreementLinkCheckbox = !customerAgreementLinkCheckbox" 
                        />
                        <a  :href="customerAgreementLink.link" 
                            class="label__medium" 
                            @click="openAgreement"
                        >
                            {{ tokens.registerModal.customerAgreement }}
                        </a>
                    </template>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { REGISTER } from "@/store/actions.type";
import { NOTIFICATION_ERROR } from '@/store/mutations.type'
import { LOGO, NEW_DESIGN, ROLE, TRADINGVIEW_THEME, WEBSITE, LOGO_REDIRECT_OFF, HIDE_LOGO, PRIVACY_POLICY_LINK, CUSTOMER_AGREEMENT_LINK, BRAND } from "@/common/config";
import { countryToPhoneCode, hidePass, showPass, countriesList } from "@/common/helpers";
import BaseInput from "@/new-design/shared/ui/Inputs/BaseInput";
import BaseButton from "@/new-design/shared/ui/buttons/BaseButton";
import SearchCountrySelect from '@/new-design/shared/ui/selects/SearchCountrySelect'
import SearchCurrencySelect from '@/new-design/shared/ui/selects/SearchCurrencySelect'
import BaseButtonSmall from "@/new-design/shared/ui/buttons/BaseButtonSmall";
import BaseModalTitle from "@/new-design/shared/ui/titles/BaseModalTitle";
import BaseLogo from "@/new-design/shared/ui/Icons/BaseLogo";
import BaseCheckbox from "@/new-design/shared/ui/Inputs/BaseCheckbox";
import {DEFAULT_COUNTRY_REGISTER} from "@/common/config";

export default {
    name: "RegisterModal",
    components: {
        BaseInput,
        BaseButton,
        SearchCountrySelect,
        SearchCurrencySelect,
        BaseButtonSmall,
        BaseModalTitle,
        BaseLogo,
        BaseCheckbox
    },
    mounted() {
        this.chooseCountry(countriesList()[this.defaultCountryRegister.toUpperCase()])
    },
    data() {
        return {
            newDesign: NEW_DESIGN,
            firstname: '',
            lastname: '',
            country: '',
            language: '',
            email: '',
            password: '',
            password2: '',
            manager_id: '',
            existPromo: false,
            role: ROLE,
            phone: '',
            flag: '',
            website: WEBSITE,
            tradingViewTheme: TRADINGVIEW_THEME,
            logo: LOGO,
            logoRedirectOff: LOGO_REDIRECT_OFF,
            hideLogo: HIDE_LOGO,
            privacyAndPolicyLink: PRIVACY_POLICY_LINK,
            customerAgreementLinkCheckbox: false,
            currencyChosen: BRAND === 'royalwealthltd' ? 'CAD' : 'USD',
            defaultCountryRegister: DEFAULT_COUNTRY_REGISTER,
            brand: BRAND,
        }
    },
    methods: {
        showPass,
        hidePass,
        filPhoneNumber() {
            if (this.phone === '' && this.newDesign) {
                this.phone += "+"
            }
        },
        chooseCountry(country) {
            this.$set(this, 'country', country)
            this.setPhone(country)
        },
        setPhone(country) {
            let selectedCountry = countryToPhoneCode(country)
            if (selectedCountry) {
                this.$set(this, 'phone', selectedCountry[1])
                this.$set(this, 'flag', selectedCountry[2].toLowerCase())
            }
        },
        register() {
            if (!this.customerAgreementLinkCheckbox && this.customerAgreementLink.link) {
                this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.pleaseConfirmAgreement)
                return
            }

            if (!this.email) {
                this.$store.commit(NOTIFICATION_ERROR, 'INVALID_EMAIL')
                return
            }

            if (!this.phone || !(/^\+?[0-9]+$/.test(this.phone))) {
                this.$store.commit(NOTIFICATION_ERROR, 'INVALID_PHONE')
                return
            }

            if(!this.password){
                this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.pleaseEnterPassword)
                return
            }

            if((this.password !== this.password2)){
                this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.passwordNotSame)
                return
            }

            let manager_id = parseInt(this.manager_id)

            if (isNaN(manager_id) || manager_id <= 0) {
                manager_id = 0
            }

            if (manager_id) {
                this.role = 1
            }

            if(this.country){
                const countryCodesEntries = Object.entries(countriesList()).find(([, val]) => val === this.country);
                this.language = countryCodesEntries ? countryCodesEntries[0] : "";
            }

            let data = {
                firstname: this.firstname,
                lastname: this.lastname,
                country: this.country,
                language: this.language,
                phone: this.phone,
                email: this.email.trim(),
                currency: this.currencyChosen,
                password: this.password.trim(),
                manager_id,
                role: this.role
            }

            localStorage.setItem('userRegisterEmail', data.email)

            const urlParams = new URLSearchParams(window.location.search);
            const referredBy = urlParams.get('referred_by');

            if (referredBy) {
                data.referred_by = referredBy;
            }

            this.$store.dispatch(REGISTER, data)
        },
        goToLoginPage() {
            window.location.href = '/';
        },
        async openAgreement(e) {
            e.preventDefault();
            const { link: defaultLink, fileLocalization } = this.customerAgreementLink;
            if(!defaultLink){
                return
            }

            if (fileLocalization) {
                let localizedLink = defaultLink.replace('.pdf',`_${this.langActive}.pdf`);
                let defaultLangLink = defaultLink.replace('.pdf','_gb.pdf');

                try {
                    const res = await fetch(localizedLink, { method: 'HEAD' });

                    let finalUrl = res.ok ? localizedLink : defaultLangLink;
                    window.open(finalUrl, '_blank');


                } catch(e) {
                    window.open(defaultLangLink, '_blank');
                }

            } else {
                if(defaultLink.toLowerCase().endsWith('.pdf')) {
                    const a = document.createElement('a');
                    a.href = defaultLink;
                    a.download = '';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    return
                }else{
                    window.open(defaultLink, '_blank');
                }
            }
        }
    },
    computed: {
        ...mapGetters(['modals', 'tokens', 'currencies', 'staticBase','langActive']),
        logoComputed() {
            return this.tradingViewTheme === 'Light' ? this.logo.url.replace(/white/, 'black') : this.logo.url
        },
        customerAgreementLink(){
            let type = "customerAgreement";
            let link = CUSTOMER_AGREEMENT_LINK || false;
            let fileLocalization = false

            if(['stage','finquickly','stockmkts','tradreview','bvtrend'].includes(this.brand)){
                type = "termsAndConditions";
            }

            if(link && link?.toLowerCase()?.endsWith('.pdf')) {
                let basePath = this.staticBase && this.staticBase.replace("image/", `brands/${this.brand}/`);
                if(link === 'documents/account_openning.pdf') {
                    fileLocalization = true
                }
                link = basePath + link;
            }

            return { link, type, fileLocalization }
        }
    }
}
</script>

<style scoped>
.new-design.mobile.banner-is-active .modal-wrapper {
    height: calc(100% - 44px);
}

.modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    top: auto;
}

.theme_3-logo {
    display: inline-block;
    width: max-content;
    text-align: center;
    margin: 0 0 35px;
    position: absolute;
    top: 12px;
    left: 10px;
}

.modal {
    width: 620px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 26px 20px;
    z-index: 1100;
    border-radius: 8px;
    border: 1px solid var(--System-OutlineVariant);
    background: var(--System-Surface1);
    position: relative;
    overflow-y: auto;
    top: 15px;
    max-height: 90%;
    height: calc(100% - 70px);
}

.title-wrapper {
    margin-bottom: 34px;
}

.modal-title-left {
    color: var(--System-OnSurface);
    display: flex;
    align-items: center;
    gap: 12px;
}

.modal-title-left i {
    font-size: 18px;
}

.modal-title-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
}

.modal-box {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 40px;
}

.name-inputs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.name-inputs .input-container{
    width: 100%;
}

.modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.modal-footer button {
    margin-left: auto;
}

.modal-forgot {
    display: flex;
    align-items: center;
    gap: 10px;
}

.modal-footer-additional {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.customer-agreement {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 5px;
}

.promo {
    margin: 10px 0;
    cursor: pointer;
    text-decoration: underline dotted var(--System-OnSurfaceVariant);
    color: var(--System-OnSurfaceVariant);
}

.privacy-policy a,
.customer-agreement a{
    color: var(--System-Primary);
    text-decoration: underline var(--System-Primary);
    cursor: pointer;
}

@media(max-width: 1024px) {
    .modal {
        top: 35px;
        height: calc(100% - 110px);
    }
}

@media(max-width: 768px) {
    .modal {
        margin-inline: 32px;
    }
}
</style>
